<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="6">
            <b-button variant="success" @click="$router.push({ name: 'add_parameter' })">
              <feather-icon icon="FileIcon" class="mr-50" />
              <span class="align-middle">Nuevo</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <div style="display:block" id="listaRequests">
        <b-card-body>
          <div class="d-flex justify-content-between  flex-wrap">
            <!-- filter -->
            <b-form-group label-for="filterInput" class="mb-0">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Buscar" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </b-card-body>
        <b-table responsive class="position-relative" :busy="isLoading" :per-page="perPage" :current-page="currentPage"
          :items="items" :small="true" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" @filtered="cPaginacion">
          <template #cell(Status)="data">
            <div class="text-nowrap">
              <div v-if="data.item.Status == 'Activo'">
                <b-badge pill variant="success">Activo</b-badge>
              </div>
              <div v-else>
                <b-badge pill variant="danger">Inactivo</b-badge>
              </div>
            </div>
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap row">
              <div class="col-md-6">
                <feather-icon :id="`${data.item.id}-view-icon`" icon="EyeIcon" class="cursor-pointer" size="16"
                  @click="$router.push({ name: 'view_parameter', params: { id: data.item.id } })" />
                <b-tooltip title="Ver parámetro" class="cursor-pointer" :target="`${data.item.id}-view-icon`" />
              </div>
              <div class="col-md-6">
                <feather-icon :id="`${data.item.id}-view-icon2`" icon="PowerIcon" class="cursor-pointer" size="16"
                  @click="toggle_parameter(data.item.id)" />
                <b-tooltip title="Activar/Desactivar" class="cursor-pointer" :target="`${data.item.id}-view-icon2`" />
              </div>
            </div>
          </template>
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
          <!-- page length -->
          <b-form-group label="Mostrar" label-cols="5" label-align="left" label-size="sm" label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1">
            <b-form-select id="perPageSelect2" v-model="perPage" size="sm" inline :options="pageOptions" />
          </b-form-group>
          <!-- pagination -->
          <div>
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number
              prev-class="prev-item" next-class="next-item" class="mb-0">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from '@axios'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import moment from 'moment';

import {
  BBadge,
  BCard,
  BTable,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BModal,
  VBModal,
  BRow,
  BCol,
  BProgress,
  BTooltip,
  BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BBadge,
    BCard,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BModal,
    BRow,
    BCol,
    BProgress,
    BTooltip,
    vSelect,
    BSpinner,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'Name',
          label: 'Nombre',
          sortable: true,
        },
        {
          key: 'Status',
          label: 'Estado',
          sortable: true,
        },
        {
          key: 'Creation_Date',
          label: 'Fecha Creación',
          sortable: true,
        },
        {
          key: 'Created_By_Name',
          label: 'Creado Por',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false,
        },
      ],
      items: [],
      isLoading: true,
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({
          text: f.label,
          value: f.key,
        }))
    },
  },
  mounted() {
    this.get_parameters()
  },
  methods: {
    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    get_parameters() {
      const URL = '/nomina/parameter'
      const config = {
        method: 'get', url: URL, params: {
          user_id: this.getUserID(),
        }
      }
      this.isLoading = true
      axios(config)
        .then(response => {
          if (response && response.status === 200) {
            let lst_response = this.format_to_table(response.data.response)
            this.items = lst_response
            this.totalRows = this.items.length
            this.isLoading = false
          }
        })
        .catch(error => {
          this.isLoading = false
          this.printErrorModal(error)
        });
    },
    format_to_table(lst_valuation) {
      let formated_array = []
      formated_array = lst_valuation.map(valuation => {
        valuation["Creation_Date"] = moment(valuation["Creation_Date"]).format('DD/MM/YYYY h:mm A')
        return valuation
      })
      return formated_array
    },
    toggle_parameter(parameter_id) {
      this.$swal({
        title: '¿Estas seguro?',
        text: "Se cambiará el estado del parámetro",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          let config = {}
          // Solo se crea 1 registro
          const URL = '/nomina/parameter/toggle'
          config = {
            method: 'put',
            url: URL,
            data: {
              "parameter_id": parameter_id,
              "user_id": this.getUserID(),
            },
          }
          // Send data to server
          axios(config)
            .then(response => {
              if (response && response.status === 200) {
                this.get_parameters()
                this.$swal({
                  icon: 'success',
                  title: '¡Estado cambiado!',
                  text: 'El estado del parámetro ha cambiado',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              } else {
                this.printErrorModal('Error en el servidor')
              }
            })
            .catch(error => {
              this.printErrorModal(error)
            });
        }
      })
    },
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const id = jsonUserData.id
      return id
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
  },
}
</script>
